import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';
import { DURATIONS } from '../constants/onboardingData';

/**
 * Step 4: Sélection de la durée quotidienne
 */
export default function Step4Duration({
  formData,
  currentStepNumber,
  currentStepMessage,
  canContinue,
  onSelectDuration,
  onContinue,
  onBack,
}) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto">
        {/* Icône et Titre */}
        <div className="text-center py-6">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Combien de temps par jour ?
          </h1>
          <p className="text-gray-500">
            Pour le travail avec GeniMi
          </p>
        </div>

        {/* Bandeau info */}
        <div className="bg-yellow-100 rounded-xl p-3 mb-6 border border-yellow-200">
          <div className="flex items-center justify-center gap-2">
            <span className="text-xl">⭐</span>
            <p className="text-gray-700 text-sm font-medium">
              10 minutes par jour suffisent pour voir les premiers progrès
            </p>
          </div>
        </div>

        {/* Grille des durées */}
        <div className="grid grid-cols-2 gap-4">
          {DURATIONS.map((duration) => (
            <div
              key={duration.id}
              onClick={() => onSelectDuration(duration.id)}
              className={`
                relative bg-white rounded-2xl p-4 border-[3px] shadow-lg cursor-pointer transition-all
                ${formData.dailyDuration === duration.id
                  ? 'border-[#059669] bg-[#F0FDFA]'
                  : 'border-gray-200 hover:border-gray-200'
                }
              `}
            >
              {/* Badge Recommandé */}
              {duration.recommended && (
                <div className="absolute -top-2 -right-2 bg-orange-400 text-white text-xs px-2 py-1 rounded-full font-medium flex items-center gap-1">
                  <span>✨</span> Recommandé
                </div>
              )}

              <div className="text-center">
                {/* Nombre */}
                <div className={`
                  w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-3
                  text-white font-bold text-xl shadow-lg
                  ${duration.id === 5 ? 'bg-gradient-to-br from-green-400 to-emerald-500' : ''}
                  ${duration.id === 10 ? 'bg-gradient-to-br from-emerald-500 to-teal-500' : ''}
                  ${duration.id === 15 ? 'bg-gradient-to-br from-teal-500 to-cyan-500' : ''}
                  ${duration.id === 20 ? 'bg-gradient-to-br from-cyan-500 to-blue-500' : ''}
                `}>
                  {duration.id}
                </div>

                {/* Label */}
                <p className="font-semibold text-gray-800 mb-1">{duration.label}</p>
                <p className="text-gray-500 text-sm">{duration.description}</p>

                {/* Radio */}
                <div className={`
                  w-5 h-5 rounded-full border-2 mx-auto mt-3 flex items-center justify-center
                  ${formData.dailyDuration === duration.id
                    ? 'border-[#059669] bg-[#059669]'
                    : 'border-gray-300'
                  }
                `}>
                  {formData.dailyDuration === duration.id && (
                    <div className="w-2 h-2 rounded-full bg-white" />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Info "Le saviez-vous" */}
        <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-2xl p-5 mb-6 mt-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
              <span className="text-xl">📈</span>
            </div>
            <div>
              <p className="font-semibold text-gray-800 mb-1">Le saviez-vous ?</p>
              <p className="text-gray-600 text-xs">
                Les enfants qui travaillent 10 minutes par jour avec GeniMi progressent{' '}
                <span className="font-semibold text-sm">3 fois plus vite</span> que ceux qui font des sessions longues mais irrégulières.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        <ContinueButton
          onClick={onContinue}
          disabled={!canContinue}
        />
      </div>
    </div>
  );
}
